var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 14,
    viewBox: "0 0 142 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00419513H10.1784C10.4404 0.00419513 10.6893 0.0127815 10.9295 0.0256689C11.1653 0.0385564 11.4971 0.0815182 11.925 0.150251C12.353 0.22328 12.7416 0.317785 13.0909 0.442363C13.4402 0.566942 13.8114 0.751667 14.2044 1.00512C14.5974 1.25857 14.9292 1.55498 15.1999 1.89864C15.4707 2.24231 15.6934 2.67619 15.8724 3.20887C16.0514 3.74155 16.1387 4.34296 16.1387 5.01311C16.1387 7.16101 15.2916 8.69462 13.5931 9.61392L16.4313 13.6305L11.126 13.609L8.75929 10.4086H4.59797V13.6305H0V0.00419513ZM9.74176 6.42643C10.8858 6.42643 11.4578 6.00115 11.4578 5.14628C11.4578 4.36874 10.8596 3.98211 9.66316 3.98211H4.59361V6.42643H9.74176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3913 0.0430001L35.6049 13.6264H30.2777L29.2341 11.3367H22.3918L21.3482 13.6264H16.0603L22.252 0.0430001H29.3913ZM24.0248 7.41461H27.5967L25.802 3.8448L24.0248 7.41461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1534 0.00430001L53.3546 13.5662L53.3765 13.6263H48.9401L48.9619 13.5662L45.687 6.36639L42.4514 13.622H38.015L32.1376 0H36.9888L40.2244 7.70239L43.46 0H47.8572L51.1321 7.62506L54.3284 0H59.1622L59.1534 0.00430001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7644 13.6264H60.2366V0.0430001H69.7032C70.5984 0.0430001 71.3931 0.0902524 72.0917 0.189056C72.7904 0.28786 73.4934 0.481174 74.2008 0.768993C74.9125 1.06111 75.502 1.44773 75.978 1.93315C76.4496 2.41858 76.8338 3.07584 77.1307 3.90064C77.4277 4.72973 77.5761 5.70488 77.5761 6.83038C77.5761 7.8399 77.4189 8.74631 77.1045 9.54533C76.7901 10.3486 76.3753 10.9973 75.8601 11.4956C75.3492 11.9939 74.7422 12.4063 74.0436 12.7371C73.3449 13.0679 72.6463 13.2956 71.9433 13.4244C71.2403 13.5533 70.5111 13.6178 69.7644 13.6178V13.6264ZM69.45 9.91907C70.1748 9.91907 70.7905 9.7816 71.3058 9.50238C71.8167 9.22315 72.1922 8.858 72.428 8.40694C72.6638 7.95588 72.7817 7.43609 72.7817 6.85616C72.7817 5.92397 72.5153 5.17649 71.9826 4.61374C71.4499 4.05099 70.6028 3.76747 69.45 3.76747H64.8345V9.91907H69.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6843 0.0430001L95.8979 13.6264H90.5707L89.5271 11.3367H82.6804L81.6367 13.6264H76.3489L82.5406 0.0430001H89.6843ZM84.3222 7.41461H87.894L86.0993 3.8448L84.3222 7.41461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4266 0.00419513H110.709V4.5062H103.867V13.6262H99.2908V4.5062H92.4266V0.00419513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.093 12.3032C115.093 13.1752 114.373 13.884 113.486 13.884C112.6 13.884 111.879 13.1752 111.879 12.3032C111.879 11.4311 112.6 10.7223 113.486 10.7223C114.373 10.7223 115.093 11.4311 115.093 12.3032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.376 0.416576L136.59 13.9999H131.263L130.219 11.7103H123.377L122.333 13.9999H117.045L123.237 0.416576H130.376ZM125.014 7.79248H128.586L126.791 4.22266L125.014 7.79248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.402 14V0.377981H142V14H137.402Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTitle);
export default __webpack_public_path__ + "static/media/LOGO_Title.2cc97cb6f035af303d6abe60a3ada103.svg";
export { ForwardRef as ReactComponent };